import styled, { css } from 'styled-components';
import { playFontSize } from '../helpers';
import { extraLightCoolGrey, lightYellow, fontWeightBold, fontWeightRegular } from '../../design-tokens';
import { device } from '../../breakpoints';
import { TYPES } from './PlayText';

const getFontSize = (type) => {
    switch (type) {
        case TYPES.MINI:
            return `${playFontSize(1.2)}`;
        case TYPES.SMALL:
            return `${playFontSize(1.4)}`;
        case TYPES.DEFAULT:
            return `${playFontSize(1.5)}`;
        case TYPES.LARGE:
            return `${playFontSize(1.6)}`;
        case TYPES.XLARGE:
            return `${playFontSize(1.8)}`;
        case TYPES.XXLARGE:
            return `${playFontSize(2)}`;
        default:
            return `${playFontSize(1.5)}`;
    }
};

const getFontSizeGteSmall = (type) => {
    switch (type) {
        case TYPES.MINI:
            return `${playFontSize(1.3)}`;
        case TYPES.SMALL:
            return `${playFontSize(1.5)}`;
        case TYPES.DEFAULT:
            return `${playFontSize(1.6)}`;
        case TYPES.LARGE:
            return `${playFontSize(1.7)}`;
        case TYPES.XLARGE:
            return `${playFontSize(2.2)}`;
        case TYPES.XXLARGE:
            return `${playFontSize(3)}`;
        default:
            return `${playFontSize(1.6)}`;
    }
};

export const PlayTextStyles = css`
    line-height: 1.4;
    margin: 0;
    font-weight: ${(props) => (props.weight ? props.weight : fontWeightRegular)};
    color: ${(props) => (props.color ? props.color : extraLightCoolGrey)};
    ${(props) => getFontSize(props.type)};

    ${(props) =>
        props.error &&
        css`
            color: ${lightYellow};
            font-weight: ${fontWeightBold};
            font-style: normal;
        `}

    @media ${device.GteSmall} {
        ${(props) => getFontSizeGteSmall(props.type)}
    }
    
    text-decoration: ${(props) => (props.underline ? 'underline' : 'none')};
`;

export const StyledPlayText = styled.p`
    ${PlayTextStyles}
`;

export const PlayTextError = styled.p`
    color: ${lightYellow};
    font-weight: ${fontWeightBold};
    font-style: normal;
`;
